import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../../elements/Box';
import { getWeekDayName } from '../../../../helpers/localization/localizationUtils';

const renderWeekDates = (translate, props, localizationData) => {
  const days = [];
  for (let index = 0; index < 7; index += 1) {
    const weekday = index;
    days.push(
      <Box
        key={weekday}
        className="DayPicker-Weekday"
        role="columnheader"
        {...props}
        dataTestId="dayPickerWeekday"
      >
        <abbr>{getWeekDayName(weekday, props.weekDayFormat, translate, localizationData)}</abbr>
      </Box>
    );
  }
  return days;
};

const WeekDays = ({ showBorder, weekDaysContainer, weekDaysElement }) => {
  const { translate, localizationData } = useContext(Context);
  return (
    <Box
      {...weekDaysContainer}
      display="table"
      width="100"
      borderBottom={showBorder}
      position="absolute"
      left="0"
      top="1"
      className="fr-datepicker-weekdays-mobile"
    >
      <Box className="DayPicker-Weekdays" role="rowgroup">
        <Box className="DayPicker-WeekdaysRow" role="row">
          {renderWeekDates(translate, weekDaysElement, localizationData)}
        </Box>
      </Box>
    </Box>
  );
};

WeekDays.propTypes = {
  showBorder: PropTypes.bool,
  weekDaysContainer: PropTypes.objectOf(PropTypes.any),
  weekDaysElement: PropTypes.objectOf(PropTypes.any),
};

WeekDays.defaultProps = {
  showBorder: true,
  weekDaysContainer: {
    bgColor: 'white',
    paddingWidth: '2',
  },
  weekDaysElement: {
    weekDayFormat: 'oneLetter',
    fontWeight: 'bold',
    textColor: 'black',
    fontSize: '4',
  },
};

WeekDays.componentName = 'WeekDays';

export default WeekDays;
